import React, { useState } from 'react';
import { Form, Button, Card, Container, Alert, Col, Row, Modal } from 'react-bootstrap';
import { firestore } from "../../firebase";
import { useHistory } from 'react-router-dom';

export default function CreateSeller() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showAlert, setShowAlert] = useState("");
    const [codigo, setCodigo] = useState("");
    const [nombre, setNombre] = useState("");
    const [notas, setNotas] = useState("");
    const history = useHistory();

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!codigo || !nombre) {
            setError("Uno o más campos requeridos no llenados");
            setLoading(false);
            return null;
        }

        const createCodigo = codigo.trim();
        const createNombre = nombre.trim();
        const createNotas = notas.trim();

        const duplicatesCodigo = await firestore
        .collection('vendedores')
        .where('codigo', '==', createCodigo)
        .get();

        if (!duplicatesCodigo.empty) {
            setError("El código del vendedor ya está en uso");
            setLoading(false);
            return null;            
        }

        const newVendedor = {
            codigo: createCodigo,
            nombre: createNombre,
            notas: createNotas
        }

        firestore.collection('vendedores').add(newVendedor)
        .then(() => {
            setShowAlert(true);
            setLoading(false);
        })
        .catch(() => {
            setError('Ocurrió un error inesperado, vuélvalo a intentar más tarde');
            setLoading(false);
        })
    }

    function handleClose() {
        setShowAlert(false);
        history.push("/sellers");
    }

    return (
        <Container 
        className="d-flex align-items-center justify-content-center"
        >
            <div className="w-100" style = {{ maxWidth: "500px"}}>
                <h2 className="text-center mt-3 mb-4">Crear Vendedor</h2>
                <Modal show={showAlert} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>Éxito</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Se creó el vendedor correctamente
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleClose}>
                            Regresar
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Card>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-codigo">
                                    <Form.Label>Código</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={codigo}
                                    onChange={e => setCodigo(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-nombre">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control 
                                    type="text" 
                                    value={nombre}
                                    onChange={e => setNombre(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className="m-2">
                                <Form.Group className="mb-3" id="vendedor-notas">
                                    <Form.Label>Notas (opcional)</Form.Label>
                                    <Form.Control 
                                    as="textarea" rows={3}
                                    value={notas}
                                    onChange={e => setNotas(e.target.value)}
                                    disabled={loading}/>
                                </Form.Group>
                            </Row>
                            <Row className='m-2'>
                                <Col xs={3}>
                                    <Button disabled={loading} type="submit">Confirmar</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
}